const ajaxURL = adminurl.ajaxurl;

$(function(){

    // const fileInput = document.getElementById('file');
    // fileInput.onchange = () => {
    //     const selectedFile = fileInput.files[0];
    //     console.log(selectedFile);
    // }

    $( 'form[name="leave-comment"]' ).on( 'submit', function() {
        var form_data = $( this ).serializeArray();
        var nonce = $( this ).find('input[name="nonce"]').val();
        var file = $(this).find('input[name="file"]').prop('files')[0];
        console.log(file);
        var comment = $(this).find('textarea[name="comment"]').val();
        var post_id = $(this).find('input[name="post_id"]').val();
        var post_type = $(this).find('input[name="post_type"]').val();
        var formData = new FormData();

        console.log(comment);

        formData.append('file', file);
        formData.append('comment', comment);
        formData.append('post_id', post_id);
        formData.append('security', nonce);
        formData.append('post_type', post_type);
        formData.append('action', 'leave_comment');

        // Here is the ajax petition.
        jQuery.ajax({
            url : ajaxURL, // Here goes our WordPress AJAX endpoint.
            type : 'post',
            contentType: false,
            processData: false,
            data : formData,
            success : function( response ) {
                // You can craft something here to handle the message return
                window.location.reload();
            },
            fail : function( err ) {
                // You can craft something here to handle an error if something goes wrong when doing the AJAX request.
                alert( "There was an error: " + err );
            }
        });

        // This return prevents the submit event to refresh the page.
        return false;
    });
})